import { z } from 'zod';
import { userRoleSchema } from '../roles.js';
export const emailSchema = z
    .string({ required_error: 'Adresse e-mail requise' })
    .trim()
    .toLowerCase()
    .min(3, 'Adresse e-mail requise')
    .max(180, 'Adresse e-mail trop longue')
    .email('Adresse e-mail invalide');
/** Politique de mot de passe (P0, a arbitrer avec KN si une politique interne existe). */
export const passwordSchema = z
    .string({ required_error: 'Mot de passe requis' })
    .min(12, 'Le mot de passe doit contenir au moins 12 caractères')
    .max(128, 'Le mot de passe ne doit pas dépasser 128 caractères')
    .regex(/[a-z]/, 'Le mot de passe doit contenir au moins une minuscule')
    .regex(/[A-Z]/, 'Le mot de passe doit contenir au moins une majuscule')
    .regex(/[0-9]/, 'Le mot de passe doit contenir au moins un chiffre');
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string({ required_error: 'Mot de passe requis' }).min(1, 'Mot de passe requis'),
});
export const changePasswordSchema = z.object({
    currentPassword: z
        .string({ required_error: 'Mot de passe actuel requis' })
        .min(1, 'Mot de passe actuel requis'),
    newPassword: passwordSchema,
});
/** Identite renvoyee par GET /api/auth/me et POST /api/auth/login. */
export const sessionUserSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string(),
    role: userRoleSchema,
    mustChangePassword: z.boolean(),
});
//# sourceMappingURL=auth.js.map